import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { RepairServiceInfosManagement } from '../components/RepairServiceInfosManagement';
import { useNavigate } from 'react-router-dom';
import {
  TRepairServiceSchema,
  repairServiceSchema,
} from '@/schemas/repair-service/repair-service.schema';
import { useCreateRepairService } from '@/hooks/repair-service.hooks';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '@/utils/language.utils';

export const CreateRepairServicePage = () => {
  const { t } = useTranslation('repairService');
  const navigate = useNavigate();

  const {
    watch: watchRepairService,
    control: repairServiceControl,
    register: registerRepairService,
    setValue: setRepairServiceValue,
    setError: setRepairServiceError,
    handleSubmit: handleSubmitRepairService,
    formState: {
      errors: repairServiceErrors,
      isSubmitting: isSubmittingRepairService,
    },
  } = useForm<TRepairServiceSchema>({
    resolver: zodResolver(repairServiceSchema),
  });

  const {
    mutate: mutateCreateRepairService,
    isPending: isPendingCreateRepairService,
  } = useCreateRepairService({
    t,
    handleSuccess: () => navigate('/repair-services'),
  });

  const onSubmitRepairService = (repairService: TRepairServiceSchema) => {
    const { languageCode } = getLanguage();

    const dataWithLanguageCode = {
      ...repairService,
      languageCode,
    };

    mutateCreateRepairService(dataWithLanguageCode);
  };

  return (
    <>
      <PageHeader
        backToLink="/repair-services"
        title={t('addRepairService')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem
              text={t('repairServiceList')}
              linkTo="/repair-services"
            />
            <BreadcrumbItem text={t('addRepairService')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <RepairServiceInfosManagement<TRepairServiceSchema>
          t={t}
          watch={watchRepairService}
          control={repairServiceControl}
          register={registerRepairService}
          setValue={setRepairServiceValue}
          setError={setRepairServiceError}
          errors={repairServiceErrors}
          submitDisabled={
            isSubmittingRepairService || isPendingCreateRepairService
          }
          onSubmit={handleSubmitRepairService(onSubmitRepairService)}
        />
      </div>
    </>
  );
};
